export enum ProjectFields {
  startDate = 'startDate',
  timezone = 'timezone',
  projectLifetime = 'projectLifetime',
}
